import { Button, Dialog, Icon, Pagination, Tab, Table, Tree } from "@alifd/next";
import { BefGlobalContext, BefMessageButtonType, BefMessageServiceContext, BefMessageType, BefRpcContext } from "@beflam/bef-core";
import { useContext, useEffect, useRef, useState } from "react";
import AddDep from "./AddDep";
import EditDep from "./EditDep";
import AddDepType from "./AddDepType";
import EditDepType from "./EditDepType";
import AddUser from "./AddUser";
import AssignUser from "./AssignUser";
import { MixIcon } from "../MixIcon";
import { DropdownButton } from "../dropdown-button";
import DepTypeRoleAssign from "./DepTypeRoleAssign";
import CopyDepTyep from "./CopyDepTyep";
import { ExcelImport } from "../ExcelImport";
import saveAs from "file-saver";
export function DepList() {
    const befRpc = useContext(BefRpcContext);
    const messageService = useContext(BefMessageServiceContext);
    const sGlobal = useContext(BefGlobalContext);
    const [isShowTable, setIsShowTable] = useState(false);
    let [dataSource, setDataSource] = useState({ data: [] as any[], dataSource: [] as any[], currentPage: 1, selectedRowKeys: [], selectRecords: [] as any[], columnWidth: {} as any });
    let [typeSource, setTypeSource] = useState({ data: [] as any[], dataSource: [] as any[], currentPage: 1 });

    let [visible, setVisible] = useState({ add: false, edit: false, addType: false, editType: false, addUser: false, assignUser: false, editTypeRole: false, ref: false, excelImport: false });
    const pageSize = 15;
    const maxScollerHeight = '450px';
    const rpcAssembly = "Beflam.Framework";
    const rpcModule = "Beflam.Framework.Service.DepartmentService";
    const [selectedKeys, setSelectedKeys] = useState<any>([]);
    const [expandedKeys, setExpandedKeys] = useState(selectedKeys);
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const [treeData, setTreeData] = useState<any>();
    const [allDeps, setAllDeps] = useState<any>();
    const [allDepUsers, setAllDepUsers] = useState<any>([]);
    const [typeData, setTypeData] = useState<any>();
    let [depData, setDepData] = useState<any>();
    const [selectUsers, setSelectUsers] = useState<any>()
    const [roleDatas, setRoleDatas] = useState<any>([]);
    let depRef = useRef<any>(null);
    let editDepRef = useRef<any>(null);
    let currentDepRef = useRef<any>(null);
    const [currentTab, setCurrenttab] = useState<any>(1);
    const dataAdapter: any = {};
    const [divHeight, setDivHeight] = useState<any>(0);
    const perRef = useRef(null);
    const [divHeight1, setDivHeight1] = useState<any>("232px");
    const perRef1 = useRef(null);
    dataAdapter.importExcel = async (data: any) => {
        return await befRpc.callRpcAsync<string>("", rpcAssembly, rpcModule, "Import", data);
    }
    const columns = [
        // { header: "GUID", key: "Id" },
        { header: "用户编号", key: "UserId" },
        { header: "职级编号", key: "DepType" }]

    const refresh = async (_isShow: boolean = false) => {
        try {
            let result = await befRpc.callRpcAsync<any[]>("", rpcAssembly, rpcModule, "Tree", { AppId: sGlobal.currentAppId });
            setTreeData(formatTree(result));
            setAllDeps(getAllDep(result));
            if (_isShow === false) {
                currentDepRef.current = null;
                setIsShowTable(false);
            } else {
                setIsShowTable(true);
                getUserList(currentDepRef.current, 1);
                setSelectedKeys([currentDepRef.current]);
                setExpandedKeys([currentDepRef.current]);
                openEditDialog(currentDepRef.current);
            }
            typeSource = { data: [] as any[], dataSource: [] as any[], currentPage: 1 };
            setTypeSource({ data: [] as any[], dataSource: [] as any[], currentPage: 1 });
            setCurrenttab(1);

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "部门刷新"));
        }
    }
    const refreshDep = async (isRefreshTree = true) => {
        try {
            if (isRefreshTree) {
                let result = await befRpc.callRpcAsync<any[]>("", rpcAssembly, rpcModule, "Tree", { AppId: sGlobal.currentAppId });
                setTreeData(formatTree(result));
                setAllDeps(getAllDep(result));
                openEditDialog(currentDepRef.current);
            }
            getUserList(currentDepRef.current, 1);

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "部门刷新"));
        }
    }
    function getPageData(datas: any, current: any) {
        let data = datas.slice((current - 1) * pageSize, current * pageSize);
        return data;
    }
    function formatTree(datas: any) {
        let result = [] as any;
        if (datas !== undefined && datas !== null && datas.length > 0) {
            for (const data of datas) {
                let temp = { label: '', key: '', children: [] };
                temp.key = data.Id;
                temp.label = data.Name;
                if (data.hasOwnProperty("Child") && data.Child !== undefined && data.Child !== null && data.Child.length > 0) {
                    temp.children = formatTree(data.Child);
                }
                result.push(temp);
            }
        }

        return result;
    }
    function getAllDep(datas: any) {
        let result = [] as any;
        if (datas !== undefined && datas !== null && datas.length > 0) {
            for (const data of datas) {
                let temp = { Id: '', Name: '' };
                temp.Id = data.Id;
                temp.Name = data.Name;
                if (data.hasOwnProperty("Child") && data.Child !== undefined && data.Child !== null && data.Child.length > 0) {
                    let temps = getAllDep(data.Child);
                    result = [...result, ...temps];
                }
                result.push(temp);

            }
        }

        return result;
    }
    const setDataSourceEx = (data: any) => {
        dataSource = data;
        setDataSource(data);
    }
    const setTypeDataSourceEx = (data: any) => {
        typeSource = data;
        setTypeSource(data);
    }
    const onPaginationChange = (current: number, e?: any) => {
        let result = dataSource.data.slice((current - 1) * pageSize, current * pageSize);
        setDataSourceEx({ ...dataSource, dataSource: result, currentPage: current });
    }
    const onTypePaginationChange = (current: number, e?: any) => {
        let result = typeSource.data.slice((current - 1) * pageSize, current * pageSize);
        setTypeDataSourceEx({ ...typeSource, dataSource: result, currentPage: current });
    }
    const onTreeSelect = async (keys: any, extra: any) => {
        try {
            if (keys.length > 0) {
                openEditDialog(keys[0]);
                setIsShowTable(true);
                getUserList(keys[0], 1);
                setSelectedKeys([keys[0]]);
                setExpandedKeys([keys[0]]);
                setAutoExpandParent(true);
                getDepTypeList(keys[0], 1)
                setCurrenttab(1);
                currentDepRef.current = keys[0];

            }
            else {
                if (!currentDepRef.current)
                    setIsShowTable(false);
            }
        }
        catch (ex) {
            messageService.showMessage(messageService.handleErr(ex, "部门切换"));
        }
    }
    const getDepTypeList = async (id: any, current: any) => {
        let typeRes = await befRpc.callRpcAsync<any[]>("", rpcAssembly, rpcModule, "TypeList", { AppId: sGlobal.currentAppId, Id: id });
        typeSource = { data: typeRes, currentPage: 1, dataSource: getPageData(typeRes, current) };
        setTypeSource({ data: typeRes, currentPage: 1, dataSource: getPageData(typeRes, current) });
    }
    const getUserList = async (id: any, current: any) => {
        let res = await befRpc.callRpcAsync<any[]>("", rpcAssembly, rpcModule, "UserList", { Id: id, AppId: sGlobal.currentAppId });
        let result = res.slice((current - 1) * pageSize, current * pageSize);
        setDataSourceEx({ ...dataSource, data: res, dataSource: result, currentPage: current, selectedRowKeys: [], selectRecords: [] });
        setAllDepUsers(res);
    }
    const setVisibleEx = (data: any) => {
        visible = data;
        setVisible(data);
    }

    const openAddDialog = () => {
        setVisibleEx({ ...visible, add: true });
    }
    const openAddUserDialog = () => {
        setVisibleEx({ ...visible, addUser: true });
    }
    const openAssignUserDialog = () => {
        try {
            //    console.log(dataSource.selectedRowKeys)
            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0 || dataSource.selectedRowKeys.length > 1) throw new Error("请选择一条数据");
            const user = dataSource.selectRecords.filter((val) => val.UserId);
            setSelectUsers(user[0]);
            setVisibleEx({ ...visible, assignUser: true });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "配置职级"));
        }

    }
    const setDepDataEx = (data: any) => {
        depData = data;
        setDepData(data);
    }
    const openEditDialog = async (id: any) => {
        try {
            // if (currentDepRef == null || currentDepRef.current == null || currentDepRef.current === undefined)
            //     throw new Error('部门编号丢失');
            if (id && id !== '') {
                let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Get", { AppId: sGlobal.currentAppId, Id: id, Data: {} });

                setDepDataEx(result);
            }
            else throw new Error('部门编号丢失');

            // setVisibleEx({ ...visible, edit: true });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "编辑部门"));
        }
    }
    const openAddTypeDialog = async () => {
        let result = await befRpc.callRpcAsync("", rpcAssembly, "Beflam.Framework.Service.UserService", "Permission", { Action: "Get", Type: "Role", Users: [] });
        setRoleDatas(result);
        setVisibleEx({ ...visible, addType: true });
    }
    const openEditTypeDialog = async (data: any) => {
        try {
            if (data == null || data === undefined || data.hasOwnProperty('Id') === false)
                throw new Error('级别编号丢失');
            let result = await befRpc.callRpcAsync("", rpcAssembly, "Beflam.Framework.Service.UserService", "Permission", { Action: "Get", Type: "Role", Users: [] });
            setRoleDatas(result);
            setTypeData(data);
            setVisibleEx({ ...visible, editType: true });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "部门树获取"));
        }

    }
    const openEditTypeRoleDialog = async (data: any) => {
        try {
            if (data == null || data === undefined || data.hasOwnProperty('Id') === false)
                throw new Error('级别编号丢失');
            setTypeData(data);
            setVisibleEx({ ...visible, editTypeRole: true });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "部门树获取"));
        }

    }
    const onAdd = async () => {
        try {
            if (!depRef || !depRef.current) throw new Error("系统错误：depRef is null");
            let validateResult = await depRef.current.validate();
            if (validateResult.errors != null) return;
            let data = depRef.current.dataSource;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Create", { AppId: sGlobal.currentAppId, Id: data.Id, Data: data });
            messageService.showMessage({ mes: `新增部门<${data.Id}>成功` });
            setVisibleEx({ ...visible, add: false });
            currentDepRef.current = data.Id;
            refresh(true);
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "新增部门"));
        }
    }
    const onAddUser = async () => {
        try {
            if (currentDepRef == null || currentDepRef.current == null || currentDepRef.current === undefined)
                throw new Error('部门编号丢失');
            if (!depRef || !depRef.current) throw new Error("系统错误：depRef is null");
            let data = depRef.current.dataSource;
            if (data.length > 0) {
                for (let user of data) {
                    if (user.UserId === undefined || user.UserId == null || user.UserId === '')
                        throw new Error('请填写用户Id');
                }
                await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "UserAdd", { AppId: sGlobal.currentAppId, Id: currentDepRef.current, Data: data });
                messageService.showMessage({ mes: `新增用户成功` });
                getUserList(currentDepRef.current, 1);
            }
            setVisibleEx({ ...visible, addUser: false });

            //  refresh();
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "新增用户"));
        }
    }
    const onAddType = async () => {
        try {
            if (!depRef || !depRef.current) throw new Error("系统错误：depRef is null");
            if (!currentDepRef || !currentDepRef.current) throw new Error("缺少部门Id");
            let validateResult = await depRef.current.validate();
            if (validateResult.errors != null) return;
            let data = depRef.current.dataSource;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "TypeAdd", { AppId: sGlobal.currentAppId, Id: currentDepRef.current, Data: data });
            messageService.showMessage({ mes: `新增级别<${data.Id}>成功` });
            setVisibleEx({ ...visible, addType: false });
            refreshType();
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "新增级别"));
        }
    }
    const onEdit = async () => {
        try {
            if (!editDepRef || !editDepRef.current) throw new Error("系统错误：editDepRef is null");
            let validateResult = await editDepRef.current.validate();
            if (validateResult.errors != null) return;
            let data = editDepRef.current.dataSource;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Update", { AppId: sGlobal.currentAppId, Id: data.Id, Data: data });
            messageService.showMessage({ mes: `更新部门<${data.Id}>成功` });
            setVisibleEx({ ...visible, edit: false });
            refresh(true);
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "编辑部门"));
        }
    }
    const onEditType = async () => {
        try {
            if (!currentDepRef || !currentDepRef.current) throw new Error("缺少部门Id");
            let validateResult = await depRef.current.validate();
            if (validateResult.errors != null) return;
            let data = depRef.current.dataSource;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "TypeUpdate", { AppId: sGlobal.currentAppId, Id: currentDepRef.current, Data: data });
            messageService.showMessage({ mes: `更新级别<${data.Id}>成功` });
            setVisibleEx({ ...visible, editType: false });
            refreshType();
            refreshDep(false);
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "编辑级别"));
        }
    }
    const onEditTypeRole = async () => {
        try {
            if (!depRef || !depRef.current) throw new Error("depRef is null");
            await depRef.current.save();
            messageService.showMessage({ mes: `职级Id：<${typeData.Id}>权限配置成功` });
            setVisibleEx({ ...visible, editTypeRole: false });
            refreshType();
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "编辑级别权限"));
        }
    }

    const onAssignUser = async () => {
        try {
            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0) throw new Error("请选择至少一条数据");
            const userIds = dataSource.selectRecords.map((val) => val.UserId);
            if (currentDepRef == null || currentDepRef.current == null || currentDepRef.current === undefined)
                throw new Error('部门编号丢失');
            let data = depRef.current.dataSource;
            if (data.DepType === undefined)
                data.DepType = "";
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "UserUpdate", { AppId: sGlobal.currentAppId, Id: currentDepRef.current, Data: data });
            messageService.showMessage({ mes: `配置用户<${userIds.join(",")}>成功` });
            getUserList(currentDepRef.current, dataSource.currentPage);
            setVisibleEx({ ...visible, assignUser: false });

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "配置用户"));
        }
    }
    const onDelete = async () => {
        try {
            if (currentDepRef == null || currentDepRef.current == null || currentDepRef.current === undefined)
                throw new Error('部门编号丢失');
            let messageResult = await messageService.showMessage({ mes: `是否确定删除当前部门<${currentDepRef.current}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (messageResult === 1) {
                await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Delete", { AppId: sGlobal.currentAppId, Id: currentDepRef.current, Data: { Id: currentDepRef.current } });
                messageService.showMessage({ mes: `删除部门<${currentDepRef.current}>成功` });
                refresh();
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除部门"));
        }
    }
    const onDeleteUser = async () => {
        try {
            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0) throw new Error("请选择至少一条数据");
            const userIds = dataSource.selectRecords.map((val) => val.UserId);
            if (currentDepRef == null || currentDepRef.current == null || currentDepRef.current === undefined)
                throw new Error('部门编号丢失');
            let messageResult = await messageService.showMessage({ mes: `是否确定删除用户<${userIds.join(",")}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (messageResult === 1) {
                await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "UserDelete", { AppId: sGlobal.currentAppId, Id: currentDepRef.current, Data: userIds });
                messageService.showMessage({ mes: `删除用户<${userIds.join(",")}>成功` });
                getUserList(currentDepRef.current, 1);
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除用户"));
        }
    }
    const onDeleteType = async (data: any) => {
        try {
            if (!currentDepRef || !currentDepRef.current) throw new Error("缺少部门Id");
            if (data == null || data === undefined || data.hasOwnProperty('Id') === false)
                throw new Error('级别编号丢失');
            let messageResult = await messageService.showMessage({ mes: `是否确定删除级别<${data.Id}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (messageResult === 1) {
                await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "TypeDelete", { AppId: sGlobal.currentAppId, Id: currentDepRef.current, Data: { Id: data.Id } });
                messageService.showMessage({ mes: `删除级别<${data.Id}>成功` });
                refreshType();
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除级别"));
        }
    }
    const onCopyDepType = async () => {
        try {
            if (!depRef || !depRef.current) throw new Error("depRef is null");
            let data = depRef.current.dataSource;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "TypeRef", { AppId: sGlobal.currentAppId, Id: currentDepRef.current, Data: data });

            messageService.showMessage({ mes: `职级引用成功` });
            setVisibleEx({ ...visible, ref: false });
            refreshType();
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "职级引用"));
        }
    }
    const typeRender = (value: any, index: any, record: any) => {
        return (<>
            <DropdownButton className="ellipsis-btn" style={{ borderRadius: '5px', padding: 0, width: '33px', height: '33px', color: '#262A2A', backgroundColor: '#F6F6F6', border: '1px solid #E8E8E8' }} type="normal" size="medium" popupTriggerType="click" icon="ellipsis" content=""
                itemClick={(args) => depGroupClick(value, record, args)}
                items={[
                    { id: 'editType', icon: '1:pencil', children: '编辑' },
                    { id: 'editTpyeRole', icon: '1:people', children: '配置权限' },
                    { id: 'deleteType', icon: '1:trash', children: '删除' },
                ]} />
        </>
        );
    };
    const refreshType = async (page = 1) => {
        try {
            if (currentDepRef && currentDepRef.current) {
                let typeRes = await befRpc.callRpcAsync<any[]>("", rpcAssembly, rpcModule, "TypeList", { AppId: sGlobal.currentAppId, Id: currentDepRef.current });
                typeSource = { data: typeRes, currentPage: page, dataSource: getPageData(typeRes, page) };
                setTypeSource({ data: typeRes, currentPage: page, dataSource: getPageData(typeRes, page) });
            } else {
                throw "请选择部门"
            }

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "部门职级获取"));
        }
    }
    const onTabChange = (key: any) => {
        setCurrenttab(key);
    }
    const departmentRender = (value: any, index: number, record: any) => {
        return <>
            <DropdownButton className="ellipsis-btn" style={{ borderRadius: '5px', padding: 0, width: '33px', height: '33px', color: '#262A2A', backgroundColor: '#F6F6F6', border: '1px solid #E8E8E8' }} type="normal" size="medium" popupTriggerType="click" icon="ellipsis" content=""
                itemClick={(args) => depGroupClick(value, record, args)}
                items={[
                    { id: 'editDep', icon: '1:pencil', children: '配置职级' },
                    { id: 'deleteDep', icon: '1:trash', children: '删除用户' },
                ]} />
        </>;
    };
    const depGroupClick = (value: any, record: any, args: { id: string, item: any, event: React.MouseEvent | React.KeyboardEvent }) => {
        switch (args.id) {
            case 'editDep': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [record.UserId], selectRecords: [record] });
                openAssignUserDialog();
                break;
            }
            case 'deleteDep': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [record.UserId], selectRecords: [record] });
                setDataSourceEx({ ...dataSource, selectRecords: [record] });
                onDeleteUser();
                break;
            }
            case 'editType': {
                openEditTypeDialog(record);
                break;
            }
            case 'deleteType': {
                onDeleteType(record);
                break;
            }
            case 'editTpyeRole': {

                openEditTypeRoleDialog(record);
                break;
            }

        }
    }
    const groupItemClick = (args: { id: string, item: any, event: React.MouseEvent | React.KeyboardEvent }) => {
        switch (args.id) {
            case 'exportData': {
                exportData();
                break;
            }
            case 'importData': {
                importData();
                break;
            }
        }
    };
    const exportData = async () => {
        try {
            let result = await befRpc.callRpcAsync<string>("", rpcAssembly, rpcModule, "Export", { Wheres: null, columns: columns, convertFields: {}, DepId: currentDepRef.current, AppId: sGlobal.currentAppId });
            saveAs(`${sGlobal.config.host}/${result}`);
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "部门用户导出"));
        }
    }
    const importData = () => {
        setVisibleEx({ ...visible, excelImport: true });
    }
    useEffect(() => {
        refresh();
    }, []);
    useEffect(() => {

   if(isShowTable){
         const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                //   console.log('Element size changed:', width, height);
                let _height = height;
                if (height > 0) {
                    let diff = _height - 110.45;
                    if (diff > 0) {
                        if (divHeight !== diff.toString() + 'px')
                            setDivHeight(diff.toString() + 'px');
                    }
                    else
                        setDivHeight('232px');
                }

            }
        });

        if (perRef.current) {
            resizeObserver.observe(perRef.current);
        }
        const resizeObserver1 = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                //   console.log('Element size changed:', width, height);
                let _height = height;
                if (height > 0) {
                    let diff = _height - 110.45;
                    if (diff > 0) {
                        if (divHeight1 !== diff.toString() + 'px')
                            setDivHeight1(diff.toString() + 'px');
                    }
                    else
                        setDivHeight1('232px');
                }

            }
        });

        if (perRef1.current) {
            resizeObserver1.observe(perRef1.current);
        }
        return () => {
            if (perRef.current) {
                resizeObserver.unobserve(perRef.current);
            }
            if (perRef1.current) {
                resizeObserver1.unobserve(perRef1.current);
            }
        };

   }
    }, [currentTab,isShowTable])

    return (
        <>
            <div className="bef-department bef-department-section bef-custom-dep">
                <div className="bef-department-header">
                    <span className="bef-department-title">部门管理</span>
                </div>
                <div className="bef-department-main" style={{ overflow: 'hidden' }}>
                    <div className="tree-div">
                        <div className="bef-department-btngroup">
                            <Button className="custom-btn sp" style={{ color: '#ffffff', backgroundColor: '#0cc763', borderColor: '#0cc763', width: '100%' }} type="normal" size="medium" onClick={openAddDialog}><MixIcon value="1:add" size="xs" />新增部门</Button>
                        </div>
                        <div className="margin-top-16" >
                            <Tree className="bef-dep-tree"
                                dataSource={treeData}
                                selectedKeys={selectedKeys}
                                onSelect={onTreeSelect}
                                expandedKeys={expandedKeys}
                                onExpand={(keys, extra) => {
                                    setExpandedKeys(keys);
                                    setAutoExpandParent(false);
                                }}
                                autoExpandParent={autoExpandParent}
                            />
                        </div>
                    </div>
                    <div className="tab-div" style={{ overflow: 'hidden' }}>
                        <Tab onChange={onTabChange} activeKey={currentTab}>
                            <Tab.Item title="部门信息" key="1">
                                <div className="tab-item">


                                    {isShowTable &&
                                        <div className="dep-div">
                                            <div className="bef-department-btngroup " style={{ flexDirection: 'row-reverse' }}>
                                                <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#3B5998', borderColor: '#3B5998' }} type="normal" size="medium" onClick={() => refreshDep(true)}><MixIcon value="1:reload" size="xs" />刷新</Button>
                                                <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#0cc763', borderColor: '#0cc763' }} type="normal" size="medium" onClick={onEdit}><MixIcon value="1:save" size="xs" />保存</Button>
                                                <Button className="custom-btn " style={{ color: '#222f36', backgroundColor: '#f7f8fa', borderColor: '#f7f8fa' }} type="normal" size="medium" onClick={onDelete}><MixIcon value="1:trash" size="xs" />删除部门</Button>

                                            </div>
                                            <div className="margin-top-16">
                                                <EditDep ref={editDepRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} options={allDepUsers} depData={depData} />


                                            </div>
                                            <div className="bef-department-btngroup " style={{ flexDirection: 'row-reverse' }}>
                                                <DropdownButton className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#3B5998', borderColor: '#3B5998' }} type="normal" size="medium" popupTriggerType="click" content="导入/导出" icon="1:chevronDown" itemClick={groupItemClick}
                                                    items={[
                                                        { id: 'exportData', icon: '1:cloudDownload', children: '导出' },
                                                        { id: 'importData', icon: '1:cloudUpload', children: '导入' }
                                                    ]} />
                                                <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#0cc763', borderColor: '#0cc763' }} type="normal" size="medium" onClick={openAssignUserDialog}><MixIcon value="1:pencil" size="xs" />配置职级</Button>
                                                <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#0c9cfc', borderColor: '#0c9cfc' }} type="normal" size="medium" onClick={openAddUserDialog}><MixIcon value="1:add" size="xs" />新增用户</Button>
                                                <Button className="custom-btn " style={{ color: '#222f36', backgroundColor: '#f7f8fa', borderColor: '#f7f8fa' }} type="normal" size="medium" onClick={onDeleteUser}><MixIcon value="1:trash" size="xs" />删除用户</Button>
                                            </div>
                                            <div className=" flex-1 margin-top-16 custom-table display-flex-col " style={{ overflow: 'hidden' }} ref={perRef}>
                                                <Table.StickyLock className=" flex-1 bef-department-content"
                                                    fixedHeader size='medium' maxBodyHeight={divHeight} primaryKey="UserId"
                                                    dataSource={dataSource?.dataSource} hasBorder={false}
                                                    rowSelection={{ selectedRowKeys: dataSource.selectedRowKeys, onChange: (selectedKeys, records) => setDataSourceEx({ ...dataSource, selectedRowKeys: selectedKeys, selectRecords: records }) }}
                                                    onResizeChange={(dataIndex: string, value: number) => {

                                                    }}>
                                                    <Table.Column lock="right" title="操作" cell={departmentRender} width={77} />
                                                    <Table.Column title="用户编号" dataIndex="UserId" />
                                                    <Table.Column title="用户名称" dataIndex="UserName" />
                                                    <Table.Column title="部门级别" dataIndex="DepType" />
                                                    <Table.Column title="部门级别名称" dataIndex="DepTypeName" />
                                                </Table.StickyLock>
                                                <div className="display-flex justify-end margin-top-8 margin-bottom-8 margin-right-6">
                                                    <Pagination shape="no-border" pageSize={pageSize} total={dataSource.data.length} current={dataSource.currentPage} onChange={onPaginationChange} />
                                                </div>
                                            </div>

                                        </div>
                                    }

                                </div>


                            </Tab.Item>
                            <Tab.Item title="级别信息" key="2">
                                <div className="tab1-item">
                                    {isShowTable && <>
                                        <div className="bef-department-btngroup " style={{ flexDirection: 'row-reverse' }}>
                                            <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#3B5998', borderColor: '#3B5998' }} type="normal" size="medium" onClick={() => refreshType(1)}><MixIcon value="1:reload" size="xs" />刷新</Button>
                                            <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#0cc763', borderColor: '#0cc763' }} type="normal" size="medium" onClick={openAddTypeDialog}><MixIcon value="1:add" size="xs" />新增</Button>
                                            <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#0c9cfc', borderColor: '#0c9cfc' }} type="normal" size="medium" onClick={() => setVisibleEx({ ...visible, ref: true })}><MixIcon value="1:duplicateOutline" size="xs" />引用</Button>
                                        </div>
                                        <div className="flex-1 margin-top-16 custom-table display-flex-col " ref={perRef1}>
                                            <Table.StickyLock className=" flex-1 bef-department-content" fixedHeader size='medium' maxBodyHeight={divHeight1} primaryKey="UserId" dataSource={typeSource?.dataSource} hasBorder={false}

                                                onResizeChange={(dataIndex: string, value: number) => {

                                                }}>
                                                <Table.Column lock="right" title="操作" cell={typeRender} width={77} />
                                                <Table.Column title="级别编号" dataIndex="Id" />
                                                <Table.Column title="级别名称" dataIndex="Name" />

                                            </Table.StickyLock>
                                            <div className="display-flex  justify-end margin-top-8 margin-bottom-8 margin-right-6">
                                                <Pagination shape="no-border" pageSize={pageSize} total={typeSource.data.length} current={typeSource.currentPage} onChange={onTypePaginationChange} />
                                            </div>
                                        </div>
                                    </>}


                                </div>
                            </Tab.Item>
                        </Tab>
                    </div>
                </div>

            </div>

            <Dialog v2 title="新增部门" width={600} visible={visible.add} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, add: false })} onOk={onAdd}>
                <AddDep ref={depRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} options={allDeps} />
            </Dialog>
            <Dialog v2 title="新增用户" width={600} visible={visible.addUser} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, addUser: false })} onOk={onAddUser} >
                <AddUser ref={depRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} depId={currentDepRef.current} />
            </Dialog>
            <Dialog v2 title="配置职级" width={600} visible={visible.assignUser} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, assignUser: false })} onOk={onAssignUser} >
                <AssignUser ref={depRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} data={selectUsers} depId={currentDepRef.current} />
            </Dialog>
            <Dialog v2 title="新增级别" width={600} visible={visible.addType} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, addType: false })} onOk={onAddType}>
                <AddDepType ref={depRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} options={roleDatas} />
            </Dialog>
            <Dialog v2 title="编辑级别" width={600} visible={visible.editType} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, editType: false })} onOk={onEditType}>
                <EditDepType ref={depRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} data={typeData} options={roleDatas} />
            </Dialog>
            <Dialog v2 title="编辑部门" width={600} visible={visible.edit} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, edit: false })} onOk={onEdit}>
                <EditDep ref={depRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} options={allDeps} depData={depData} />
            </Dialog>
            <Dialog v2 title="配置职级权限" width={800} visible={visible.editTypeRole} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, editTypeRole: false })} onOk={onEditTypeRole}>
                <DepTypeRoleAssign ref={depRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} typeData={typeData} depId={currentDepRef.current} />
            </Dialog>
            <Dialog v2 title="职级引用" width={600} visible={visible.ref} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, ref: false })} onOk={onCopyDepType}>
                <CopyDepTyep ref={depRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} typeData={typeData} depId={currentDepRef.current} options={allDeps} />
            </Dialog>

            <Dialog v2 title="Excel Import" visible={visible.excelImport} footer={false} closeMode={['close', 'esc']} width={650}
                onClose={() => {
                    setVisibleEx({ ...visible, excelImport: false });
                    refreshDep(false);
                }} >
                <ExcelImport importParams={{ dataAdapter: dataAdapter, columns: columns, convertFields: {}, DepId: currentDepRef.current, AppId: sGlobal.currentAppId }}
                    onClose={() => {
                        setVisibleEx({ ...visible, excelImport: false });
                        refreshDep(false);
                    }
                    }></ExcelImport>
            </Dialog>
        </>
    );
}